import { useState } from 'react';
import { Link } from 'react-router-dom';

const ModalButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <button className="trigger-button" onClick={toggleModal}>
        <span className='modal_line-top'></span>
        <span className='modal_line-bottom'></span>
      </button>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={toggleModal}>&#215;</button>
            <div className="modal-body">
              <Link to='/'>HOME</Link>
              <Link to='/about'>ABOUT</Link>
              <Link to='/team'>TEAM</Link>
              <Link to='/services'>SERVICES</Link>
              <Link to='/how-its-work'>HOW IT WORKS</Link>
              <Link to='/blog'>BLOG</Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalButton;